// src/components/common/Footer.jsx
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  Chip,
  IconButton,
  Stack,
} from "@mui/material";
import {
  LinkedIn,
  Twitter,
  Email,
  Phone,
  Facebook,
  Instagram,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import Logo from "./Logo";
import styles from "./Footer.module.css";

const Footer = () => {
  const footerLinks = {
    company: [
      { text: "About", path: "/about" },
      { text: "Innovation", path: "/innovation" },
      { text: "Partners", path: "/partners" },
      { text: "Contact", path: "/contact" },
    ],
    solutions: [
      { text: "Hardware", path: "/case-study/hardware" },
      { text: "Software", path: "/case-study/software-integration" },

      // { text: "Internship", path: "/internship" },
    ],
    services: [
      { text: "Mobile Apps", path: "/services/software/mobile" },
      { text: "Web Apps", path: "/services/software/web" },
      { text: "Hardware Products", path: "/services/hardware" },
      {
        text: "Software Integration",
        path: "/case-study/software-integration",
      },
    ],
  };

  return (
    <Box component="footer" className={styles.footer}>
      <Container maxWidth="xl">
        <Grid container spacing={4} className={styles.footerGrid}>
          {/* Company Info */}
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Logo variant="light" />
            <Typography variant="body2" className={styles.companyDescription}>
              UK-based engineering & software consultancy. Hardware · software ·
              embedded · cloud solutions.
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              className={styles.badgeContainer}
              flexWrap="wrap"
              gap={1}
            >
              <Chip label="🇬🇧 UK" size="small" className={styles.badgeChip} />
              <Chip
                label="ISO 9001"
                size="small"
                className={styles.badgeChip}
              />
              <Chip label="⭐ 4.9" size="small" className={styles.badgeChip} />
            </Stack>
          </Grid>

          {/* Company Links */}
          <Grid size={{ xs: 6, sm: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              className={styles.footerTitle}
            >
              Company
            </Typography>
            <Box component="ul" className={styles.footerList}>
              {footerLinks.company.map((item) => (
                <li key={item.text}>
                  <Link
                    component={RouterLink}
                    to={item.path}
                    underline="none"
                    className={styles.footerLink}
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </Box>
          </Grid>

          {/* Solutions Links */}
          <Grid size={{ xs: 6, sm: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              className={styles.footerTitle}
            >
              Solutions
            </Typography>
            <Box component="ul" className={styles.footerList}>
              {footerLinks.solutions.map((item) => (
                <li key={item.text}>
                  <Link
                    component={RouterLink}
                    to={item.path}
                    underline="none"
                    className={styles.footerLink}
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </Box>
          </Grid>

          {/* Services Links */}
          <Grid size={{ xs: 6, sm: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              className={styles.footerTitle}
            >
              Services
            </Typography>
            <Box component="ul" className={styles.footerList}>
              {footerLinks.services.map((item) => (
                <li key={item.text}>
                  <Link
                    component={RouterLink}
                    to={item.path}
                    underline="none"
                    className={styles.footerLink}
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Typography
              variant="subtitle2"
              fontWeight={600}
              className={styles.footerTitle}
            >
              Contact
            </Typography>
            <Box className={styles.contactInfo}>
              <Box className={styles.contactItem}>
                <Phone fontSize="small" className={styles.contactIcon} />
                <Typography variant="body2">+44 20 7123 4567</Typography>
              </Box>
              <Box className={styles.contactItem}>
                <Email fontSize="small" className={styles.contactIcon} />
                <Typography variant="body2">info@wavelength-uk.com</Typography>
              </Box>
              <Box className={styles.socialLinks}>
                <IconButton
                  size="small"
                  className={styles.socialIcon}
                  component="a"
                  href="#"
                  target="_blank"
                  aria-label="LinkedIn"
                >
                  <LinkedIn />
                </IconButton>
                <IconButton
                  size="small"
                  className={styles.socialIcon}
                  component="a"
                  href="#"
                  target="_blank"
                  aria-label="Twitter"
                >
                  <Twitter />
                </IconButton>
                <IconButton
                  size="small"
                  className={styles.socialIcon}
                  component="a"
                  href="#"
                  target="_blank"
                  aria-label="Facebook"
                >
                  <Facebook />
                </IconButton>
                <IconButton
                  size="small"
                  className={styles.socialIcon}
                  component="a"
                  href="#"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <Instagram />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider className={styles.footerDivider} />
        <Typography variant="caption" className={styles.copyright}>
          © 2026 Wavelength Consultancy Solutions — engineering the future
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
